import React from 'react';
import { formatPriceForMarker } from '../../../../utility/mapUtilities';

type PropertyMarkerProps = {
    addressId: string;
    popupInfoId: string;
    listPrice: number | null;
    isRental: boolean;
    isMainProperty: boolean;
    popupLoading: boolean;
    isFavorite: boolean;
  }

export function PropertyMarker({ addressId, popupInfoId, listPrice, isRental, isMainProperty, popupLoading, isFavorite }: PropertyMarkerProps) {
  const shortenedPrice = formatPriceForMarker(listPrice);
  const isSelected = addressId === popupInfoId;

  const backgroundColor = isRental
    ? (isSelected ? 'bg-purple-800' : 'bg-purple-500')
    : (isSelected ? 'bg-indigo-700' : 'bg-indigo-400');
  const dotStyling = 'flex items-center justify-center rounded-full drop-shadow fill-white text-white cursor-pointer text-lg';
  const priceContainerStyling = `absolute px-1 py-0.5 rounded-2xl cursor-pointer ${isSelected ? 'z-10' : ''}`;
  const priceStyling = 'w-max bg-white px-1 leading-3 rounded-lg';

  const markerIcon =
          (<>
            <div className={`${dotStyling} w-4 h-4 z-10 ${backgroundColor}`}></div>
            <div className={`${priceContainerStyling} mt-0.5 ${backgroundColor} ${shortenedPrice.length > 3 ? '-translate-x-1/3' : '-translate-x-1/4'}`}>
              <p className={priceStyling}>{shortenedPrice}</p>
            </div>
          </>);

  return markerIcon;
};
